import { Observable } from 'rxjs/Observable';
import setNewSongPosition from '../actions/recommendations/setNewSongPositionAction';

export function handleMoveSongPostion(action$, store) {
    return action$.filter(
        action => action.type === 'CHANGE_SONG_POSITION')
        .mergeMap((action) => Observable.merge(
            Observable.of(setNewSongPosition(
                getSongItemPostionValue(action.payload.oldIndex, action.payload.categoryId, store),
                getSongItemPostionValue(action.payload.newIndex, action.payload.categoryId, store),
                action.payload.categoryId,
                store.getState().user.data.objectId))));
}

function getSongItemPostionValue(index, categoryId, store) {
    let songs = store.getState().recommendations.data[categoryId].songs;
    return songs[index].position;
}



// WEBPACK FOOTER //
// ./src/epics/moveSongPositionEpic.js